import Vue from "vue";
import Buefy from "buefy";
import OrderDetail from "./App.vue"
import ItemList from "./components/ItemList.vue"


Vue.use(Buefy, {
  defaultIconPack: 'fas',
})
Vue.use(OrderDetail)
Vue.use(ItemList)
if(document.getElementById("orderDetailApp")){
    new Vue({
        render:h=>h(
            OrderDetail,{
                props:{
                    detailUrl:document.getElementById("orderDetailApp")
                        .getAttribute("detail-url"),
                    prodDetailUrl: document.getElementById("orderDetailApp")
                        .getAttribute("prod-detail-url"),
                    customSectionName: document.getElementById("orderDetailApp")
                        .getAttribute("custom-section-name"),
                    deliveryDateControl: document.getElementById("orderDetailApp")
                        .getAttribute("delivery-date-control"),
                    
                }
            }
        )
    }).$mount("#orderDetailApp")
}